import { z } from 'zod';
export const VideoTranscriptItemSchema = z.object({
    transcript: z.string(),
    startTime: z.number(),
    endTime: z.number(),
});
